import {edition_2023} from "./previous_editions/2023";
import {edition_2024} from "./previous_editions/2024";
import {ArticleMetadata} from "../layout/Article";
import {edition_2025} from "./previous_editions/2025";

export const previousEditions: ArticleMetadata[] = [
    edition_2023,
    edition_2024,
    edition_2025
]